import { useSelector, useDispatch } from 'react-redux'
import { Container } from './style'

export function Header({ title }) {
  const centralizedModal = useSelector(state => state.modalCentralized)

  const dispatch = useDispatch()

  return (
        <Container>
            <span onClick={() => dispatch({type: '', title: centralizedModal.title })}>
                &#10006;
            </span>
            <h2>{title}</h2>
        </Container>
  )
}